import { render, staticRenderFns } from "./UpdateUniqueIdentifier.vue?vue&type=template&id=3a1f915a"
import script from "./UpdateUniqueIdentifier.vue?vue&type=script&lang=js"
export * from "./UpdateUniqueIdentifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports